import { Button, CircularProgress, Divider, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Agendamento } from "../../../interfaces/entities/Agendamento";
import { StepIngressarAtendProps } from "../../../interfaces/props/SaudeOnline/IngressarNoAtendimento/StepIngressarAtendProps";
import { getAgendamentosTeleatendimento } from "../../../services/AgendamentoService";
import HeaderTelessaude from "./HeaderTelessaude";
import ModalAtendimentoFinalizado from "./ModalAtendimentoFinalizado";
import { sxButtonTelessaudeAtendOutlined, sxDividerIngressarAtend } from "./sxProps";

const StepAguardarFinalizacaoAtendimento: React.FC<StepIngressarAtendProps> = ({ ...props }) => {

  const [showModalAtendimentoFinalizado, setShowModalAtendimentoFinalizado] = useState<boolean>(false);
  const [meetingFinished, setMeetingFinished] = useState<boolean>(false);

  const handleShowAtendimentoFinalizado = () => {
    setShowModalAtendimentoFinalizado(showModalAtendimentoFinalizado => !showModalAtendimentoFinalizado);
  }

  const secondsInterval: number = 45000;
  const { idReuniao, zoomUrl } = { ...props };

  const handleClickBackToMeeting = () => {
    window.open(zoomUrl, '_blank');
  }

  const validateOngoingSchedules = async () => {
    const teleatendimentoSchedules = await getAgendamentosTeleatendimento();

    if (teleatendimentoSchedules !== null) {
      const ongoingSchedules = [...teleatendimentoSchedules.data]
      let meetingFinished = verifyMeetingStatus(idReuniao || '', ongoingSchedules);
      if (meetingFinished) {
        setMeetingFinished(meetingFinished);
        handleShowAtendimentoFinalizado()
      };
    } else {
      console.error('Falha ao buscar agendamentos.');
    }
  };

  useEffect(() => {
    let intervalId = setInterval(() => {
      validateOngoingSchedules();
    }, secondsInterval);

    if (meetingFinished) {
      clearInterval(intervalId);
    }

    return () => clearInterval(intervalId);
  }, [meetingFinished]);

  function verifyMeetingStatus(idReuniao: string, schedules: Agendamento[]): boolean {
    let isFinished: boolean;
    let onGoingMeeting = schedules.find(schedule => schedule.idReuniao === idReuniao || schedule.id === idReuniao);
    if (onGoingMeeting) {
      isFinished = onGoingMeeting.statusTelemedicina === 'expirado' || onGoingMeeting.statusTelemedicina === 'finalizado'; //Double check
    } else {
      isFinished = true; //Atendimento finalizado, pois não foi retornado pelo endpoint.
    }
    return isFinished;
  }

  return (
    <div className='telessaude-space-between-content'>
      <div className='ingressar-atendimento-gap-content'>
        <HeaderTelessaude />
        <CircularProgress className='margin-top-60px' color={'inherit'} thickness={5} size={50} />
        <Typography align="center">Aguarde o profissional finalizar o seu atendimento</Typography>
      </div>
      <div className='footer-service-action'>
        <Divider sx={sxDividerIngressarAtend} />
        <Typography>Deseja voltar ao seu atendimento?</Typography>
        <Button
          type='button'
          variant='outlined'
          sx={sxButtonTelessaudeAtendOutlined}
          onClick={handleClickBackToMeeting}
        >
          <Typography>Voltar para atendimento</Typography>
        </Button>
      </div>
      <ModalAtendimentoFinalizado handleShowModal={handleShowAtendimentoFinalizado} showModal={showModalAtendimentoFinalizado} />
    </div>
  )
}

export default StepAguardarFinalizacaoAtendimento;